import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/community-partner-signature.png")